<script>
    import bus from "@/bus";
    import Axios from 'axios';
    import Vue from 'vue';


    export default {
        name: "OrdersHistory",

        computed: {
            prefix_url:function () { return process.env.VUE_APP_PREFIX_URL },
            rule_order_hopshop: function (){return this.$store.getters.getRule('order') },
            rule_order_zargar: function (){return this.$store.getters.getRule('orderzargar') },
            rule_order_lots: function (){return this.$store.getters.getRule('orderlots') },
            rule_order_search: function (){return this.$store.getters.getRule('orderSearch') },
            rule_order_create_ticket: function (){return this.$store.getters.getRule('ticketCreate') },
            orderBus: function (){ return this.$store.getters.getOrderBus }
        },

        data: function () {
            return {
                loading:    false,
                data:       [],
                phone:      ''
            }
        },

        methods: {
            hideModal() {
                this.$bvModal.hide('modal-orders-history');
            },

            loadData() {
                this.loading = true;
                this.$bvModal.show('modal-orders-history');
                let url = this.prefix_url + "/api/opp?ts="+Date.now()+'&type=phone&phone='+this.phone;

                Axios
                        .get(url)
                        .then(response => {
                            this.data               = response.data.data;
                            this.loading            = false;
                });
            },
            showOrder(data) {
            console.log(data);
                bus.$emit('portal:order:open', {
                    ether_id: data.ether_id,
                    order_id: data.order_id,
                    readonly: true
                });
            },
        },

        mounted() {
            bus.$on('Orders::orders-history',(data) => {
                Object.assign(this.$data, this.$options.data.apply(this));
                this.phone  = data.phone;
                this.loadData();
            });
        },

        beforeDestroy() {
            bus.$off('Orders::orders-history');
        }
    }
</script>

<template>
    <div>
        <b-modal id="modal-orders-history" hide-footer size="xl">
            <template #modal-title>
                История заказов по номеру {{phone}}
            </template>
            <b-overlay :show="loading" rounded="sm">
            <table class="table">
                <tr>
                    <th scope="col">{{$t('main.date')}}</th>
                    <th scope="col">Retail ID</th>
                    <th scope="col">Оператор</th>
                    <th scope="col">{{$t('main.status')}}</th>
                </tr>
                <tr v-for="(item, index) in data" :key="item.id">
                    <td>{{item.ctime}}</td>
                    <td>
                        <button class="btn btn-info"  v-if="item.rid!=''" @click="showOrder(item)">
                            {{item.rid}}
                        </button>
                    </td>
                    <td>{{item.operator}}</td>
                    <td>{{item.state}}</td>
                </tr>
            </table>
            </b-overlay>
        </b-modal>
    </div>
</template>

<style scoped>

</style>